import { Button, Paper, styled } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import { useNavigate } from "hooks/routerHooks";
import { useStartCalculationStudyArea } from "hooks/studyAreaHooks";

import { deserializeErrors } from "utils/ErrorUtils";

import { NavLink } from "components/navigation/NavLink";

interface Props {
  uuid: string;
}

export function MeasuresFooter(props: Props) {
  const { uuid } = props;
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync } = useStartCalculationStudyArea(uuid);
  const navigate = useNavigate();

  async function calculateResult() {
    await mutateAsync(uuid, {
      onSuccess: (progressId: number) => {
        navigate(`/${uuid}/progress/${progressId}`);
      },
      onError: (error) => {
        const errors = deserializeErrors(error);
        errors.map((er) => {
          return enqueueSnackbar(er.message, {
            variant: "error",
          });
        });
      },
    });
  }

  return (
    <StyledPaper elevation={0}>
      <Button
        variant="back-button"
        component={NavLink}
        to={`/${uuid}/climate-effects`}
      >
        {t("label.backToClimateEffects")}
      </Button>
      <Button variant="green-contained" onClick={calculateResult}>
        {t("label.myResult")}
      </Button>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
`;
